import React from 'react';
import { Input, Select, DatePicker } from 'antd';

const regexOptions = {
  text: ['equal', 'startsWith', 'includes', 'includesNot'],
  date: ['dateEqual', 'before', 'after'],
  number: ['numbEqual', 'less', 'more']
};

const useFilters = () => {
  const contractFilters = [
    {
      filter: 'gender',
      type: 'string',
      searchField: 'customer.gender',
      render: (
        <Select>
          <Select.Option value="MISTER">Monsieur</Select.Option>
          <Select.Option value="MADAME">Madame</Select.Option>
          <Select.Option value="NON-BINARY">Non-binaire</Select.Option>
        </Select>
      )
    },
    {
      filter: 'last_name',
      type: 'string',
      searchField: 'customer.last_name',
      render: <Input />,
      regexOptions: regexOptions.text
    },
    {
      filter: 'first_name',
      type: 'string',
      searchField: 'customer.first_name',
      render: <Input />,
      regexOptions: regexOptions.text
    },
    {
      filter: 'postal_code',
      type: 'string',
      searchField: 'customer.address.postal_code',
      render: <Input />,
      regexOptions: regexOptions.text
    },
    {
      filter: 'city',
      type: 'string',
      searchField: 'customer.address.city',
      render: <Input />,
      regexOptions: regexOptions.text
    },
    {
      filter: 'created_at',
      type: 'date',
      searchField: 'effective_date',
      render: <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />,
      regexOptions: regexOptions.date
    },
    {
      filter: 'number',
      type: 'string',
      searchField: 'number',
      render: <Input />,
      regexOptions: regexOptions.text
    },
    {
      filter: 'iban',
      type: 'string',
      searchField: 'iban',
      render: <Input />,
      regexOptions: regexOptions.text
    }
  ];

  const getFilters = (purpose) => {
    if (purpose === 'contracts') return contractFilters;
    return null;
  };

  return {
    getFilters
  };
};

export default useFilters;
